export default "__VITE_ASSET__DiqnlaDs__"